module.exports = __webpack_public_path__ + "img/image1.1cf41516.jpg";